module.exports = __webpack_public_path__ + "static/cai_software_overview-26e572463299a1f0eae4b0dcd4b7789c.png";